/* eslint-disable react/prop-types */
import React from 'react';
import { useBTSChatContext } from './BTSChatContext';

const ClassRow = ({ classItem, schoolName, schoolCode }) => {
  const { selectedClass, setSelectedClass } = useBTSChatContext();
  
  const isActive = selectedClass?.classId === classItem.classId;

  const handleClick = () => {
    setSelectedClass({
      classId: classItem.classId,
      className: classItem.className,
      schoolName,
      schoolCode,
    });
  };

  const formatUnreadCount = (count) => {
    if (!count) return '';
    return count < 10 ? `0${count}` : String(count);
  };

  return (
    <div
      onClick={handleClick}
      className={`p-3 pl-6 cursor-pointer select-none flex items-center justify-between transition-colors duration-200 ${
        isActive ? 'bg-[#F3F4F6]' : 'hover:bg-gray-100 bg-white'
      }`}
    >
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <span className="text-sm font-semibold text-gray-800">
          {classItem.className}
        </span>
        <span className="text-xs text-gray-400 truncate pr-4">
          {classItem.lastMessage || 'No messages yet'}
        </span>
      </div>

      {/* Unread Count as plain red text (no circle badge) */}
      {classItem.unreadCount > 0 && (
        <span className="text-[rgb(237,28,36)] text-xs font-bold mr-2">
          {formatUnreadCount(classItem.unreadCount)}
        </span>
      )}
    </div>
  );
};

export default ClassRow;
